import { get } from "svelte/store";
import { stats } from "../stores/finishWorkoutStats";
import type { FinishWorkoutStats } from "../interfaces/FinishWorkoutStats";
import { generateFinishExerciseArray } from "./generateFinishExerciseArray";
import { loadedWorkouts, user } from "stores";
import { isClient } from "./roles";

export const generateStats = (workoutId: number) => {
  const statsRef = get(stats);

  if (statsRef[0]?.stats[0]?.workoutId !== workoutId) {
    stats.set([]);
  }

  const loadedWorkoutRef = get(loadedWorkouts);
  const workout = loadedWorkoutRef[workoutId];

  if (!workout?.exercises) {
    stats.set([]);
    return;
  }

  const statArr: FinishWorkoutStats[] = [];
  const draftStatsByExerciseId = new Map<number, FinishWorkoutStats["stats"]>(
    statsRef[0]?.stats[0]?.workoutId === workoutId
      ? statsRef.map((stat) => [stat.exerciseId, stat.stats])
      : []
  );

  workout.exercises.forEach((exercise) => {
    if (exercise.entityType === 1) return;

    if (exercise.modelType === "superset") {
      exercise.supersetExercises.forEach((ex) => {
        const finishWorkoutStat: FinishWorkoutStats = {
          exerciseId: ex.id,
          name: ex.name,
          stats: [],
        };

        finishWorkoutStat.stats = generateFinishExerciseArray(
          ex,
          workoutId,
          draftStatsByExerciseId.get(ex.id)
        );
        statArr.push(finishWorkoutStat);
      });
    } else {
      const finishWorkoutStat: FinishWorkoutStats = {
        exerciseId: exercise.id,
        name: exercise.name,
        stats: [],
      };

      finishWorkoutStat.stats = generateFinishExerciseArray(
        exercise,
        workoutId,
        draftStatsByExerciseId.get(exercise.id)
      );
      statArr.push(finishWorkoutStat);
    }
  });

  const userRef = get(user);
  if (isClient(userRef) && userRef.trainer.id === 47803) {
    statArr.forEach((stat) => {
      stat.stats.forEach((set) => {
        set.reps = null;
      });
    });
  }

  stats.set([...statArr]);
};
